<template>
  <v-card width="100%" height="100%" outlined>
    <v-toolbar color="secondary" dark class="title" flat>
      <v-icon left>fas fa-users</v-icon>
      User Management
    </v-toolbar>
    <v-card-text>
      <!-- DIFFERENT USER DIALOGS - BUT NOT AS MODALS -->
      <userStatus v-if="dialog == 'status'" @close="dialog = ''" :selectedUser="selectedUser"></userStatus>
      <resetPass v-if="dialog == 'reset'" @close="dialog = ''" :selectedUser="selectedUser"></resetPass>
      <userAdd v-if="dialog == 'addUser'" @close="dialog = ''"></userAdd>
      <div v-if="dialog == ''">
        <v-row>
          <v-col cols="12" class="text-right">
            <v-btn outlined small @click="dialog = 'addUser'">
              <v-icon left small>fas fa-plus</v-icon>
              Add User
            </v-btn>
          </v-col>
        </v-row>
        <v-row v-for="user in getUserList" class="usertable" dense align="center" :key="user.email">
          <v-col cols="6" class="subtitle-1 black--text">
            {{user.email}}
          </v-col>
          <v-col cols="6" class="text-right">
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <v-btn icon outlined color="secondary" class="mr-1" v-on="on" @click="reset(user)">
                  <v-icon small>fas fa-redo</v-icon>
                </v-btn>
              </template>
              <span>Reset User Password</span>
            </v-tooltip>
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <v-btn
                  icon outlined
                  :color="user.status ? 'red darken-3' : 'grey lighten-3'"
                  class="ml-1" @click="changeUserStatus(user)" v-on="on"
                >
                  <v-icon small>fas fa-user-slash</v-icon>
                </v-btn>
              </template>
              <span>{{user.status ? 'Disable User' : 'Enable User'}}</span>
            </v-tooltip>
          </v-col>
        </v-row>
        <v-divider></v-divider>
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
import userStatus   from './userStatus'
import resetPass    from './resetPass'
import userAdd      from './userAdd'
export default {
  components: {
    userStatus,
    resetPass,
    userAdd
  },
  data(){
    return {
      dialog        : "",
      users         : ['markrmessmore@gmail.com', "Paul", "George", "Ringo"],
      selectedUser  : ""
    }
  },
  methods: {
    changeUserStatus(user){
      this.selectedUser = user
      this.dialog       = 'status'
    },
    reset(user){
      this.selectedUser = user.email
      this.dialog       = 'reset'
    }
  },
  computed: {
    getUserList(){
      return this.$store.getters.getUserList
    }
  }
}
</script>

<style scoped>
.usertable:nth-child(even){
  background: #CCC;
}
</style>
